module.exports = __webpack_public_path__ + "static/bar02_2_mobile-316ae886f18de1c103b0fd16b5cff00d.png";